export default __webpack_public_path__ + "static/virtual_library-80e6f725a46a1591fe121535b5c2e035.png";